import React, { useEffect, useState } from "react"
import BasicTableComponent, { NumberRangeColumnFilter, SelectColumnFilter, DateRangeColumnFilter, formatDateTime } from "../../components/basic.table"
import { fetchAndSetData } from "../../api/Axios"

// Ausserhalb der Komponente, damit die Spalten nicht bei jedem Rendern neu entstehen und die
// Zellen der neuen Spalten testbar sind
export const ticketColumns = [{
        Header: "Bearbeiten"
    }, {
        Header: "Status",
        accessor: "state_text",
        Filter: SelectColumnFilter,
        filter: 'includes',
    }, {
        Header: "Ersteller",
        accessor: "creator_name"
    }, {
        Header: "Erstellt",
        accessor: (row, _) => row.created,
        Cell: ({ value, row }) => row.original.created_formatted || formatDateTime(value),
        Filter: DateRangeColumnFilter,
        filter: 'dateBetween',
    }, {
        Header: "Zugewiesen",
        accessor: (row, _) => row.assigned,
        Cell: ({ value, row }) => row.original.assigned_formatted || formatDateTime(value),
        Filter: DateRangeColumnFilter,
        filter: 'dateBetween',
    }, {
        Header: "Bearbeiter",
        accessor: "supporter_name"
    }, {
        Header: "Geschlossen",
        accessor: (row, _) => row.closed,
        Cell: ({ value, row }) => row.original.closed_formatted || formatDateTime(value),
        Filter: DateRangeColumnFilter,
        filter: 'dateBetween',
    }, {
        Header: "Kategorie",
        accessor: "category",
        Filter: SelectColumnFilter,
        filter: 'includes',
    }, {
        Header: "Anfrage",
        accessor: "request"
    }, {
        Header: "Antwort",
        accessor: "answer"
    }, {
        Header: "Nachrichten",
        accessor: (row, _) => (row.comments === undefined || row.comments === null ? 0 : row.comments.length),
        Cell: ({ value }) => (value > 0 ? value : ""),
        Filter: NumberRangeColumnFilter,
        filter: 'between',
    }, {
        Header: "Server",
        accessor: "server",
        Filter: SelectColumnFilter,
        filter: 'includes',
    }, {
        Header: "Position",
        accessor: (row, _) => {
            return row.x + " " + row.y + " " + row.z + (row.world == null ? "" : " @ " + row.world)
        }
    }, {
        Header: "Id",
        accessor: "id",
        Filter: NumberRangeColumnFilter,
        filter: 'between',
    }]

// Deleted tickets (closed and read by their creator) are only requested on demand
export function ticketListUrl(filter, showDeleted) {
    return "/api/tickets" + (filter === undefined ? "" : "/" + filter) + (showDeleted ? "?deleted=true" : "")
}

const TicketList = ({filter}) => {
    const [tickets, setTickets] = useState([])
    const [showDeleted, setShowDeleted] = useState(false)
    useEffect(() => {
        fetchAndSetData(ticketListUrl(filter, showDeleted), "Tickets konnten nicht geladen werden.", setTickets)
    }, [filter, showDeleted])

    return (
        <div>
            <div className="icheck-primary mb-2">
                <input type="checkbox" id="showDeletedTickets" checked={showDeleted}
                    onChange={e => setShowDeleted(e.target.checked)} />
                <label htmlFor="showDeletedTickets">Gelöschte Tickets anzeigen</label>
            </div>
            <BasicTableComponent columns={ticketColumns} data={tickets} editUrlPart="ticket" />
        </div>
    )
}
   
export default TicketList